export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyB5vKYrZy274D-63iUdI2_q6M__O4Z6p_g',
    authDomain: 'apps.dev.innision.ai',
    projectId: 'ins-intranet-dev',
    storageBucket: 'ins-intranet-dev.firebasestorage.app',
    messagingSenderId: '296692467354',
    appId: '1:296692467354:web:dde729d68bb41c6d43c123',
    measurementId: 'G-WHN6N0KZSR',
  },
  samlProviderId: 'saml.okta',
  // Direct Cloud Functions URL (not the /api Hosting rewrite) so the long-running
  // SDR agent request is not capped by Firebase Hosting's 60s rewrite timeout.
  functionsUrl: 'https://europe-southwest1-ins-intranet-dev.cloudfunctions.net',
  useEmulators: false,
};
